var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-pb_5" }, [
    _c("div", { staticClass: "emd-container _highlight_header" }, [
      _c("div", { staticClass: "emd-container__header" }, [
        _c("h2", { staticClass: "emd-text _size_default _type_caption" }, [
          _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "emd-container__content" }, [
        _c(
          "div",
          { staticClass: "eu-py_3 _grid-receipt-resume" },
          [
            _c("Transaction-summary-item", {
              attrs: {
                text: _vm.authorizedText,
                value: _vm.formatCurrency(
                  _vm.charge.graphics_data.authorized.value / 100
                ),
                sign: "+",
              },
            }),
            _c("Transaction-summary-item", {
              attrs: {
                text: _vm.capturedText,
                value: _vm.formatCurrency(
                  _vm.charge.graphics_data.captured.value / 100
                ),
                sign: "+",
                classColor: "_color_success",
              },
            }),
            _vm.isPSP
              ? _c(
                  "Transaction-summary-item",
                  {
                    attrs: {
                      value: _vm.formatCurrency(_vm.discounts / 100),
                      sign: "-",
                      classColor: "_color_warning",
                    },
                  },
                  [
                    _c("template", { slot: "tippy" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "emd-text _color_warning eu-mt_2 eu-ws_nowrap",
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("discounts")) + " "),
                          _vm.hasDiscount
                            ? _c(
                                "emd-tippy",
                                {
                                  staticClass: "eu-ml_1",
                                  attrs: {
                                    id: "discounts-tippy",
                                    type: "simple",
                                    position: "bottom",
                                    content: _vm.discountsDetails,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "emd-text _color_warning uil uil-info-circle",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm.isPSP
              ? _c(
                  "Transaction-summary-item",
                  { attrs: { value: _vm.cost, sign: "-" } },
                  [
                    _c("template", { slot: "tippy" }, [
                      _c(
                        "p",
                        { staticClass: "emd-text eu-mt_2 eu-ws_nowrap" },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("cost")) + " "),
                          _c(
                            "emd-tippy",
                            {
                              staticClass: "eu-ml_1",
                              attrs: {
                                id: "cost-tippy",
                                type: "simple",
                                position: "bottom",
                                content: _vm.$t("cost-detail"),
                              },
                            },
                            [_c("i", { staticClass: "uil uil-info-circle" })]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _c("Transaction-summary-item", {
              attrs: {
                text: _vm.canceledText,
                value: _vm.formatCurrency(
                  _vm.charge.graphics_data.canceled.value / 100
                ),
                sign: "-",
                classColor: "_color_danger",
              },
            }),
            _vm.showNetValue
              ? _c(
                  "Transaction-summary-item",
                  {
                    attrs: {
                      value: _vm.showNetAmount,
                      classColor: "_color_info",
                    },
                  },
                  [
                    _c("template", { slot: "tippy" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "emd-text eu-mt_2 _color_info eu-ws_nowrap",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isPSP
                                  ? _vm.$t("net-amount")
                                  : _vm.$t("actual-amount")
                              ) +
                              " "
                          ),
                          _vm.showNetValueTippy
                            ? _c(
                                "emd-tippy",
                                {
                                  staticClass: "eu-ml_1",
                                  attrs: {
                                    id: "actual-amount-tippy",
                                    type: "simple",
                                    position: "bottom",
                                    content: _vm.$t("actual-amount-detail"),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "uil uil-info-circle _color_info",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }